/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProcedureFeedbackDto
 */
export interface UpdateProcedureFeedbackDto {
    /**
     * Feedback for the procedure generation output
     * @type {string}
     * @memberof UpdateProcedureFeedbackDto
     */
    feedback: string;
}

/**
 * Check if a given object implements the UpdateProcedureFeedbackDto interface.
 */
export function instanceOfUpdateProcedureFeedbackDto(value: object): value is UpdateProcedureFeedbackDto {
    if (!('feedback' in value) || value['feedback'] === undefined) return false;
    return true;
}

export function UpdateProcedureFeedbackDtoFromJSON(json: any): UpdateProcedureFeedbackDto {
    return UpdateProcedureFeedbackDtoFromJSONTyped(json, false);
}

export function UpdateProcedureFeedbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProcedureFeedbackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'feedback': json['feedback'],
    };
}

export function UpdateProcedureFeedbackDtoToJSON(json: any): UpdateProcedureFeedbackDto {
    return UpdateProcedureFeedbackDtoToJSONTyped(json, false);
}

export function UpdateProcedureFeedbackDtoToJSONTyped(value?: UpdateProcedureFeedbackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feedback': value['feedback'],
    };
}

